import {
  CREATE_CONNECTION_FAILURE,
  CREATE_CONNECTION_SUCCESS,
  CREATING_CONNECTION, FETCH_CONNECTION,
  FETCH_CONNECTIONS_SUCCESS, FETCHING_CONNECTION,
  FETCHING_CONNECTIONS, UPDATE_CONNECTION_SUCCESS, UPDATING_CONNECTION,
  FETCH_CONNECTION_SUCCESS,
  CHECKING_CONNECTION,
  CHECKING_CONNECTION_SUCCESS,
  CONNECTION_SUCCESS,
  CONNECTION_FAILED,
  RESET_FIELDS
} from './ConnectionsConstants';

const initialState = {
  fetchingConnections: false,
  fetchingConnection: false,
  connections: [],
  connection: {},
  creatingConnection: false,
  updatingConnection: false,
  connectionResult: '',
  checkingConnection: false
};

const ConnectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_CONNECTIONS:
      return { ...state, fetchingConnections: true };
    case FETCH_CONNECTIONS_SUCCESS:
      return { ...state, fetchingConnections: false, connections: action.connections };
    case CREATING_CONNECTION:
      return { ...state, creatingConnection: true };
    case CREATE_CONNECTION_SUCCESS:
      return { ...state, creatingConnection: false };
    case CREATE_CONNECTION_FAILURE:
      return { ...state, creatingConnection: false };
    case FETCHING_CONNECTION:
      return { ...state, fetchingConnection: true };
    case FETCH_CONNECTION:
      return { ...state, fetchingConnection: false, connection: action.connection };
    case FETCH_CONNECTION_SUCCESS:
      return { ...state, fetchingConnection: false };
    case UPDATING_CONNECTION:
      return { ...state, updatingConnection: true };
    case UPDATE_CONNECTION_SUCCESS:
      return { ...state, updatingConnection: false };
    case CHECKING_CONNECTION:
      return { ...state, checkingConnection: true };
    case CHECKING_CONNECTION_SUCCESS:
      return { ...state, checkingConnection: false, connectionResult: action.connectionResult.data.data === true ? CONNECTION_SUCCESS : CONNECTION_FAILED };
    case RESET_FIELDS:
      return { ...state, checkingConnection: false, connectionResult: '' };
    default:
      return state;
  }
};

export default ConnectionsReducer;



// WEBPACK FOOTER //
// ./src/redux/connections/ConnectionsReducer.js